<template>
    <div class="col-12">
        <div class=" row text-center ml-5">
            <h3 class="ui inverted purple text"><em data-emoji=":page_with_curl:"></em> <strong>Downloads The Addedum File
                    !</strong>
            </h3>
            <p class="text-muted fw-light mt-4">Please note you are required to download, fill in the addendum file and
                upload it during this account opening process!</p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row m-3">
                    <!-- <div class="col-sm-6 mb-3"> -->
                    <div class="card card-shadow">
                        <div class="card-body">
                            <h4 class="card-title"><strong>Addendum</strong></h4>
                            <p class="card-text text-muted fw-light"> A low KYC account that requires an Econet mobile
                                number !</p>
                            <button class="ui purple right floated  button" @click="downloads()">
                                Download
                            </button>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>

                <div class="mt-5">
                    <button class="ui button  purple fluid mt-4" @click="next()" type="submit">Next</button>
                    <button @click="back()" class="ui grey button fluid mt-3">Back</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";


export default {
    name: "Addendum",
    data() {
        return { count: 0 };
    },
    mounted() {
    },
    methods: {
        downloads() {
            const url = URLS.documents + "/download/addendum";
            console.log(url);
            http.download(url, false)
                .then(res => {
                    if (!res) return;
                    if (res.errors) return this.errors = res.errors;
                    console.log(res);

                    const fileURL = window.URL.createObjectURL(res);
                    const fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "Addendum.pdf");
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loadingForm = false;

                })
        },
        back() {
            this.$router.push("/account-opening/account-type");
        },
        next() {
            if (localStorage.getItem('account-type') === 'T24')
                this.$router.push("/account-opening/currency-type");
            else
                this.$router.push("/account-opening/remit-customer-details");

        },
        isave() {
            localStorage.setItem("account-type", "ISAVE");
            this.$router.push("/account-opening/customer-details");
        },
        submitForm() { },
        ...baseMethods,
    }
};
</script>